import Vue from 'vue';
import App from '@components/App';
import router from '@router/Index';
import store from '@store/Index';
import {sync} from 'vuex-router-sync';

sync(store, router);

import Axios from 'axios';
import Vuex from 'vuex';
import AsyncComputed from 'vue-async-computed';
import PersistedState from 'vuex-persistedstate';
import Underscore from 'underscore';
import Lodash from 'vue-lodash';
import Moment from 'moment';
import VueMoment from 'vue-moment';
import Bootstrap from 'bootstrap/dist/js/bootstrap.min';
import Popper from 'popper.js';
import jQuery from 'jquery';
import Meta from 'vue-meta';
import VeeValidate from 'vee-validate';
import Swiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';

Vue.use(AsyncComputed);
Vue.use(Vuex);
Vue.use(PersistedState);
Vue.use(Underscore);
Vue.use(Lodash);
Vue.use(Meta);
Vue.use(VeeValidate);
Vue.use(VueMoment);
Vue.use(Swiper);

Vue.axios = Axios;
Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
Vue.axios.defaults.headers.common['Authorization'] = store.state.client ? `Bearer ${store.state.client.token}` : '';
Vue.axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';

Vue.prototype.Axios = Axios;
Vue.prototype.Moment = Moment;
Vue.prototype.Underscore = Underscore;
Vue.prototype.Lodash = _;

window.$ = jQuery;

router.beforeEach((to, from, next) => {
    $('.modal').modal('hide');

    let path = to.path;
    let isRedirectAvailable = false;
    let isRedirectLanguageAvailable = false;

    path.startsWith('/hr/') || path === '/hr' ? isRedirectAvailable = true : isRedirectAvailable = false;

    if (isRedirectAvailable) {
        path.length === 3 ? router.push('/') : router.push(path.substr(3));
    }

    next();
});

Vue.config.productionTip = true;
Vue.config.devtools = true;
Vue.config.debug = true;
Vue.config.silent = true;

new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js